import { combineReducers } from "redux";
import usersSlice from "./slices/usersSlice";
import themeSlice from "./slices/themeSlice";
import dashboardSlice from "./slices/dashboardSlice";
import analysisReportsSlice from "./slices/analysisReportsSlice";
import notifierSlice from "./slices/notifierSlice";
import integrationsSlice from "./slices/integrationsSlice";
import settingsSlice from "./slices/settingsSlice";
import networkDefenderSlice from "./slices/networkDefenderSlice";
import healthCheckSlice from "./slices/healthCheckSlice";
import mailGatewaySlice from "./slices/mailGatewaySlice";
import containerSlice from "./slices/containerSlice";
import androidSlice from "./slices/androidSlice";
import zsearchSlice from "./slices/zsearchSlice";
import cdrSlice from "./slices/cdrSlice";
import fsaSlice from "./slices/fsaSlice";
import phishBoxSlice from "./slices/phishBoxSlice";
import watermarkDecoderSlice from "./slices/watermarkDecoderSlice";

const rootReducer = combineReducers({
  users: usersSlice.reducer,
  theme: themeSlice.reducer,
  dashboard: dashboardSlice.reducer,
  analysisReports: analysisReportsSlice.reducer,
  notifier: notifierSlice.reducer,
  integrations: integrationsSlice.reducer,
  settings: settingsSlice.reducer,
  networkDefender: networkDefenderSlice.reducer,
  healthCheck: healthCheckSlice.reducer,
  mailGateway: mailGatewaySlice.reducer,
  container: containerSlice.reducer,
  android: androidSlice.reducer,
  zsearch: zsearchSlice.reducer,
  cdr: cdrSlice.reducer,
  fsa: fsaSlice.reducer,
  phishBox: phishBoxSlice.reducer,
  watermarkDecoder: watermarkDecoderSlice.reducer,
});

export default rootReducer;
